import { excelSerialToJsDate, javascriptDateToMMDDYYYY, javascriptDateToYYYYMMDD } from '../helpers/date-helpers';
import { isSupportedDataType, isValidCurrency, isValidDateInput, isValidExchangeTickerSymbol } from '../helpers/args-validators';
import { FunctionCallCache } from '../helpers/functionCallCache';
import { FunctionLocationTracker } from '../helpers/functionLocationTracker';
import { KeyBuilder } from '../helpers/keyBuilder';
const SUPPORTED_SHARE_PRICE_DATATYPES = [
    'Closing_Share_Price',
    'Opening_Share_Price',
    'Daily_High',
    'Daily_Low',
    'Adjusted_Closing_Share_Price',
    'Adjusted_Opening_Share_Price',
    'Adjusted_Daily_High',
    'Adjusted_Daily_Low',
];
function validateArgs(symbol, dataType, date, currency) {
    if (!isValidExchangeTickerSymbol(symbol)) {
        throw new CustomFunctions.Error(CustomFunctions.ErrorCode.invalidValue, 'Invalid symbol (expected format: EXCHANGE:TICKER)');
    }
    if (!isSupportedDataType(SUPPORTED_SHARE_PRICE_DATATYPES, dataType)) {
        throw new CustomFunctions.Error(CustomFunctions.ErrorCode.invalidValue, 'Invalid data type');
    }
    if (!isValidCurrency(currency)) {
        throw new CustomFunctions.Error(CustomFunctions.ErrorCode.invalidValue, "Invalid currency (expected format: e.g., 'USD')");
    }
    if (!isValidDateInput(String(date))) {
        throw new CustomFunctions.Error(CustomFunctions.ErrorCode.invalidValue, 'Invalid date');
    }
    return true;
}
let delegate = () => {
    throw new CustomFunctions.Error(CustomFunctions.ErrorCode.notAvailable, 'Initializing… press F9 to recalc.');
};
export function setSharePriceDelegate(fn) {
    delegate = fn;
}
export function sharePriceDataWrapper(symbol, dataType, date, currency, invocation) {
    return delegate(symbol, dataType, date, currency, invocation);
}
export function sharePriceDataImpl(symbol, dataType, date, currency, invocation) {
    validateArgs(symbol, dataType, date, currency);
    const javascriptDate = String(date).includes('/') ? new Date(date) : excelSerialToJsDate(Number(date));
    const queryDate = javascriptDateToYYYYMMDD(javascriptDate);
    const cache = FunctionCallCache.getInstance();
    const tracker = FunctionLocationTracker.getInstance();
    const args = { symbol, dataType, date: queryDate, currency };
    const key = KeyBuilder.build('share_price_data', args);
    cache.registerByKey(key, { functionName: 'share_price_data', params: args });
    if (invocation?.address) {
        // the key contains the function name and args
        tracker.registerCell(key, invocation.address, `=ALPHA.SHARE_PRICE_DATA("${symbol}", "${dataType}", "${javascriptDateToMMDDYYYY(javascriptDate)}", "${currency}")`);
        cache.setAutoRefresh(key);
    }
    return cache.getValueForExcelByKey(key);
}
//# sourceMappingURL=sharePriceData.js.map